export const subtypes = {0:'Communication',1: 'Distribution Main',2: 'Reticulation',3: 'Trunk Main',4:'Unknown',5:'Pumping Main'}